interface IEnvs {
  NODE_ENV: string
  SENTRY_DSN: string
  SENTRY_ENV: string
  isProd: boolean
  MEDIA_BUNNY_VERSION: string
}

export const getEnvs = (): IEnvs => {
  return {
    NODE_ENV: import.meta.env.NODE_ENV || 'development',
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
    SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV || '',
    isProd: import.meta.env.MODE === 'production' || false,
    MEDIA_BUNNY_VERSION: import.meta.env.VITE_MEDIA_BUNNY_VERSION || '1.40.0'
  }
}
